export const busVideos = [
  {
    id: 1,
    src: "https://res.cloudinary.com/dylxqjhjj/video/upload/q_auto,f_auto/v1778194511/WhatsApp_Video_2026-05-07_at_18.09.35_je9go4.mp4",
    title: "VIP Transportation Experience"
  },
  {
    id: 2,
    src: "https://res.cloudinary.com/dylxqjhjj/video/upload/q_auto,f_auto/v1778194612/WhatsApp_Video_2026-05-07_at_18.17.12_evgoz8.mp4",
    title: "Luxury Bus Interior"
  },
  {
    id: 3,
    src: "https://res.cloudinary.com/dylxqjhjj/video/upload/q_auto,f_auto/v1778194637/WhatsApp_Video_2026-05-07_at_18.28.24_uaxiua.mp4",
    title: "Safe Driving & Professionalism"
  },
  {
    id: 4,
    src: "https://res.cloudinary.com/dylxqjhjj/video/upload/q_auto,f_auto/v1778194677/WhatsApp_Video_2026-05-07_at_18.23.14_wm8dnn.mp4",
    title: "Our Modern Fleet"
  },
  {
    id: 5,
    src: "https://res.cloudinary.com/dylxqjhjj/video/upload/q_auto,f_auto/v1778194701/WhatsApp_Video_2026-05-07_at_18.27.43_dpp5je.mp4",
    title: "Luxury Travel in Morocco"
  },
  {
    id: 6,
    src: "https://res.cloudinary.com/dylxqjhjj/video/upload/q_auto,f_auto/v1778194713/WhatsApp_Video_2026-05-07_at_18.25.34_hgnu5z.mp4",
    title: "VIP Service & Comfort"
  }
];
